module.exports = __webpack_public_path__ + "media/recipes/155-57e91e5a.png";